import { createAction } from "redux-actions";
import {
  CLEAN_AUTH,
  SET_AUTH_TOKEN,
  SET_AUTH_USER,
  GET_PROFILE,
} from "../../constants/index";
import { apiGet } from "../../api/index";
import { urlLogout, urlGetProfile, urlCheckSso } from "../../api/urls";

export const logoutUser = createAction(CLEAN_AUTH, (data) => data);

export const setAuthUser = createAction(SET_AUTH_USER, (data) => data);
export const setAuthToken = createAction(SET_AUTH_TOKEN, (data) => data);

/**
 * User Refresh token.
 */
export const getProfile = createAction(GET_PROFILE, () =>
  apiGet(urlGetProfile, undefined, undefined)()
);

/**
 * User Refresh token.
 */
export const userLogout = createAction(CLEAN_AUTH, (obj) =>
  apiGet(urlLogout, undefined, undefined)()
);

/**
 * User Refresh token.
 */
export const checkSsoToken = createAction("CHECK_SSO", () =>
  apiGet(urlCheckSso, undefined, undefined)()
);
